import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const UserCoordonneesEditForm = ({ address, addressExtend, postalCode, city, phone, handleChange }) => {

    return (
        <Grid container className={"mg-x-10"} spacing={2}>
            <Grid item xs={6} sm={6}>
                <TextField
                    label="Adresse"
                    name="address"
                    value={address}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    disabled={true}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TextField
                    label="Complément d'adresse"
                    name="addressExtend"
                    value={addressExtend}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    disabled={true}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TextField
                    label="Code postal"
                    name="postalCode"
                    value={postalCode}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    disabled={true}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <TextField
                    label="Ville"
                    name="city"
                    value={city}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled={true}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextField
                    label="Téléphone"
                    name="phone"
                    value={phone}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    disabled={true}
                />
            </Grid>
        </Grid>
    );
};

export default UserCoordonneesEditForm;
